import {
  BarChart3,
  FileChartLine,
  FolderCode,
  GlobeLock,
  House,
  LockKeyholeOpen,
  Mailbox,
  OctagonAlert,
  ScrollText,
  Settings,
  ShieldUser,
  SquareActivity,
  Users,
} from "lucide-react";

import type { MenuConfig } from "@/config/types";

export const MENU_SIDEBAR_MAIN: MenuConfig = [
  {
    icon: House,
    title: "navigation.home",
    path: "/",
  },
  {
    icon: Settings,
    title: "navigation.foundation",
    disabled: true,
  },
  {
    icon: BarChart3,
    title: "navigation.analytics",
    disabled: true,
  },
  {
    icon: Users,
    title: "navigation.organization",
    disabled: true,
    separator: true,
  },
  {
    icon: ScrollText,
    title: "navigation.documents",
    disabled: true,
  },
  {
    icon: FolderCode,
    title: "navigation.audit",
    disabled: true,
  },
  {
    icon: ShieldUser,
    title: "navigation.access",
    disabled: true,
  },
];

export const MENU_SIDEBAR: MenuConfig = [
  {
    title: "sections.foundation",
    children: [
      {
        title: "sectionItems.overview",
        path: "/",
        icon: House,
      },
      {
        title: "sectionItems.localization",
        disabled: true,
        icon: GlobeLock,
      },
      {
        title: "sectionItems.applicationShell",
        disabled: true,
        icon: Mailbox,
      },
    ],
  },
  {
    title: "sections.platformBoundaries",
    children: [
      {
        title: "sectionItems.apiBoundary",
        disabled: true,
        icon: LockKeyholeOpen,
      },
      {
        title: "sectionItems.safeDiagnostics",
        disabled: true,
        icon: OctagonAlert,
      },
      {
        title: "sectionItems.authorization",
        disabled: true,
        icon: ShieldUser,
      },
    ],
  },
  {
    title: "sections.futureCapabilities",
    children: [
      {
        title: "sectionItems.reporting",
        disabled: true,
        icon: FileChartLine,
      },
      {
        title: "sectionItems.monitoring",
        disabled: true,
        icon: SquareActivity,
      },
      {
        title: "sectionItems.teamManagement",
        disabled: true,
        icon: Users,
      },
    ],
  },
];
